var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.s.preloaderWrapper},[_c('div',{class:_vm.s.center},[_c('p',{class:_vm.s.loadingText},[_vm._v(" LOADING... ")]),_c('span',{class:_vm.s.spinner})])])
}
var staticRenderFns = []

export { render, staticRenderFns }